/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetDocumentSitesResponseData,
  GetDocumentSitesResponseDataFromJSON,
  GetDocumentSitesResponseDataFromJSONTyped,
  GetDocumentSitesResponseDataToJSON
} from './GetDocumentSitesResponseData'

/**
 *
 * @export
 * @interface GetDocumentSitesResponse
 */
export interface GetDocumentSitesResponse {
  /**
   *
   * @type {number}
   * @memberof GetDocumentSitesResponse
   */
  status?: number
  /**
   *
   * @type {GetDocumentSitesResponseData}
   * @memberof GetDocumentSitesResponse
   */
  data?: GetDocumentSitesResponseData
}

export function GetDocumentSitesResponseFromJSON(json: any): GetDocumentSitesResponse {
  return GetDocumentSitesResponseFromJSONTyped(json, false)
}

export function GetDocumentSitesResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetDocumentSitesResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetDocumentSitesResponseDataFromJSON(json['data'])
  }
}

export function GetDocumentSitesResponseToJSON(value?: GetDocumentSitesResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetDocumentSitesResponseDataToJSON(value.data)
  }
}
